import { render, staticRenderFns } from "./VolunteersTab.vue?vue&type=template&id=686895f6&scoped=true&"
import script from "./VolunteersTab.vue?vue&type=script&lang=js&"
export * from "./VolunteersTab.vue?vue&type=script&lang=js&"
import style0 from "./VolunteersTab.vue?vue&type=style&index=0&id=686895f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686895f6",
  null
  
)

export default component.exports